export function isPasswordValid(value) {
    const pattern = '(?=^.{6,}$)(?=.*\\d)(?=.*[^a-zA-Z0-9_]+)(?![.\\n])(?!^[a-zA-Z]*$)(?=^[^<>]+$).*$';
    const regex = new RegExp(pattern);

    return regex.test(value);
}
